import styled from 'styled-components';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';
import {
  BaseColumnWrap,
  CenteredSpaceWrap,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const FiltersWrapperDiv = styled(BaseColumnWrap)(
  props => `
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  background-color: ${props.theme.colors.goWhite.base};
  margin: 0 0 ${props.theme.spacing.base} 0;
`,
);

export const FiltersHeaderBlockDiv = styled(CenteredSpaceWrap)(
  props => `
  padding: ${props.theme.spacing.large} ${props.theme.spacing.large} 0 ${props.theme.spacing.large};
`,
);

export const ClearTextSpan = styled.span`
  cursor: pointer;
  color: ${props =>
    props.isactive === 'true'
      ? props.theme.colors.goBrandBlue.base
      : props.theme.colors.downriver.medium};
`;

export const FiltersHeadingTextWrapperH3 = styled.h3(
  props => `
  font-weight: bold;
  font-size: ${props.theme.font.custom(16)};
`,
);

// export const FilterCheckBoxListWrapper = styled.div(
//   props => `
//   padding: ${props.theme.spacing.small} 0 0;
// `,
// );

export const AppliedFiltersWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large};
`,
);

export const FiltersInfoBlockWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
`,
);

export const StarRatingWrapperSpan = styled.span(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  padding-bottom: ${props.theme.spacing.small};
  margin-right: ${props.theme.spacing.base};
`,
);

export const AverageReviewText = styled.span(
  props => `
      font-size: ${props.theme.font.base};
      font-weight: bold;
      color: ${props.theme.colors.goWhite.base};
      text-align: center;
  `,
);

export const AverageReviewWrapper = styled.div`
  margin-right: ${props => props.theme.spacing.small};
  padding: ${props => props.theme.spacing.custom(2)} ${props => props.theme.spacing.small};
  border-radius: ${props => props.theme.misc.borderRadius.small};
  background-color: ${props => getRatingsColor(props.ratingCount)};
  width: 4rem;
`;

export const TextTruncatorSpan = styled.span`
  max-width: 15rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/*** Toggle filter switch ***/

export const FilterToggleContainerOuterWrap = styled.div(
  props => `
  padding:${props.theme.spacing.large};
`,
);

export const FilterToggleInnerWrap = styled.div(
  props => `
  border: .1rem solid ${props.theme.colors.goGreen.light};
  border-radius:${props.theme.misc.borderRadius.xlarge};
  padding:${props.theme.spacing.custom(8)};
`,
);

export const FilterToggleHeaderWrap = styled.div(
  props => `
  display:flex;
  align-items: center;
  background: ${props.theme.colors.goGreen.light};
  padding: 0 ${props.theme.spacing.custom(7)}  ;
  margin-bottom: ${props.theme.spacing.base};
  height:2.8rem;
  border-radius:${props.theme.misc.borderRadius.xlarge};
  width: fit-content;
`,
);

export const FilterToggleHeaderItem = styled.span(
  props => `
  font-weight:bold;
  padding-left:${props.theme.spacing.small};
`,
);

export const FilterToggleSwitchWrapper = styled.div(
  props => `
  display:flex;
  justify-content: space-between;
  align-items: center;

`,
);

export const FilterToggleItemDescription = styled.p(
  props => `
  color: ${props.theme.colors.downriver.dark};
  max-width: 13rem;
`,
);

export const FilterToggleSwitchLabel = styled.label(
  props => `
  position: relative;
  display: flex;
  width: 3.6rem;
  height: 2rem;
  >input{
    opacity: 0;
    width: 0;
    height: 0;
  }
`,
);

export const FilterToggleCircularSwitch = styled.span(
  props => `
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props.theme.colors.goBrandBlue.light};
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: ${props.theme.misc.borderRadius.custom(34)};

  &::before{
    position: absolute;
    content: "";
    height: 2rem;
    width: 2rem;
    left: 0;
    bottom: 0;
    background-color: ${props.theme.colors.ash.dark};
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
  }
`,
);

export const FilterToggleSwitchInput = styled.input(
  props => `
  &:checked + ${FilterToggleCircularSwitch}{
    background-color: ${props.theme.colors.goBrandBlue.base};
  }
  &:checked + ${FilterToggleCircularSwitch}:before{
    transform: translateX(16px);
  }
  &:focus{
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }
`,
);
